exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.movie-wrap[data-v-55c75040] {\n     position: relative;\n     padding-bottom: 56.25%; /*アスペクト比 16:9の場合の縦幅*/\n     height: 0;\n     overflow: hidden;\n     /* width: 80vw; */\n     margin: 5vw;\n}\n.movie-wrap iframe[data-v-55c75040] {\n     position: absolute;\n     top: 0;\n     left: 0;\n     width: 100%;\n     height: 100%;\n}\n", ""]);

// exports
